import { useState } from 'react';
import { useSelector } from 'react-redux';
import { updateMenuItem } from '../../helpers/api_helper';

const useUpdateMenuItem = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const updateMenuItemHook = async (id, data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await updateMenuItem(tenantId, id, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to update menu item: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { updateMenuItem: updateMenuItemHook, loading, error };
};

export default useUpdateMenuItem;